<div class="quest-view-container">
  @if (!hideHeader()) {
    <div class="header">
      <q-svg-wrapper [iconPath]="'project-icons/chevron-left'" class="shown-on-phones" style="cursor: pointer"
                     (click)="hideEvent.emit()"
      ></q-svg-wrapper>
      <span style="width: 24px" class="hidden-on-phones"></span>

      <span class="quest-name bold-20 margin-right-4 margin-left-4">{{ quest['name'] }}</span>

      <q-svg-wrapper [iconPath]="'project-icons/close'" style="cursor: pointer"
                     (click)="closeQuest.emit()"></q-svg-wrapper>
    </div>
  }


  <div class="swiper-images-container">
    @if (images.length > 0) {
      <swiper-container init="false" navigation="true" observer="true" observeSlideChildren="true" space-between="4">
        @for (img of images; track img) {
          <swiper-slide>
            <img src="{{img.url}}" style="border-radius: 12px" alt="image" (click)="previewImage.emit(img.url)">
            @if (img.description) {
              <lib-show-more-less class="margin-left-12 regular-12 secondary-text-color" style="display: block; width: calc(100% - 24px)" [text]="img.description" [minimizedRows]="1"></lib-show-more-less>
            }
          </swiper-slide>
        }
      </swiper-container>
    } @else {
      <div class="no-images">
        <span class="semibold-16">No images</span>
      </div>
    }
  </div>

  <ng-container *transloco="let t">
    <div class="full-width flex-justify-between">
      <div id="quest-rating-container">
        <svg style="width: 24px; height: 20px">
          <use
            [attr.xlink:href]="'assets/project-icons/rating.svg#' + (getRating() >= 50 || quest['info'].rating.voters === 0? 'like' : 'dislike')"></use>
        </svg>
        <span class="semibold-14 margin-right-4" *ngIf="quest['info'].rating.voters > 0">{{ getRating() }}%</span>
        <span class="secondary-text-color regular-14">({{ quest['info'].rating.voters }})</span>
      </div>

      @if (quest['info'].availability && quest['info'].availability.type !== 'always') {
        <div class="secondary-text-color">
          {{ questAvailabilityToText(quest['info'].availability) }}
        </div>
      } @else {
        <div class="secondary-text-color">{{ t('availability.availableAlways') }}</div>
      }
    </div>

    @if (requiredLevel > 1) {
      <div class="full-width flex-justify-between">
        <div class="semibold-14">{{t('requiredLevel')}}</div>
        <div class="level-container regular-16">{{requiredLevel}}</div>
      </div>
    }

    <div id="stats-and-start-box" class="stats-structure-container">
      <div class="container top-container">
        <div class="regular-12 flex-align-center">
          <svg class="image-16 q-red margin-right-4" viewBox="0 0 20 20">
            <use xlink:href="assets/project-icons/difficulty.svg#d"></use>
          </svg>
          {{ t('difficulty') }}
        </div>
        <div class="semibold-14">
          {{ quest['info'].difficulty ? difficultyEnumToPrettyText(quest['info'].difficulty) : '-' }}
        </div>
      </div>
      <div class="container top-container">
        <div class="regular-12 flex-align-center">
          <svg class="image-16 q-blue margin-right-4" viewBox="0 0 20 20">
            <use xlink:href="assets/project-icons/distance.svg#d"></use>
          </svg>
          {{ t('distance') }}
        </div>
        <div class="semibold-14">
          {{ metersToPretty((quest['info'].approxDistance ?? 0) * 1000) }}
        </div>
      </div>
      <div class="container top-container">
        <div class="regular-12 flex-align-center">
          <svg class="image-16 q-purple margin-right-4" viewBox="0 0 20 20">
            <use xlink:href="assets/project-icons/time.svg#t"></use>
          </svg>
          {{ t('time') }}
        </div>
        <div class="semibold-14">
          {{ timeToPrettyText(quest['info'].approxTime) }}
        </div>
      </div>
      <div class="container bottom-container">
        <div class="regular-12 flex-align-center">
          <svg class="image-16 q-blue margin-right-4" viewBox="0 0 24 24">
            <use xlink:href="assets/project-icons/tag.svg#c"></use>
          </svg>
          {{ t('recommendedActivity') }}
        </div>
        <div class="semibold-14">
          {{ t(quest['info'].recommendedFor) }}
        </div>
      </div>
      @if (quest.config?.mode === QuestMode.noMap) {
        <div class="container bottom-container-2">
          <div class="regular-12 flex-align-center">
            <svg class="image-16 q-secondary margin-right-4" viewBox="0 0 24 24">
              <use xlink:href="assets/project-icons/map.svg#c"></use>
            </svg>
            {{t('questWithoutMap')}}
          </div>
          <div class="semibold-14">
          </div>
        </div>
      }
    </div>

    @if (questDescription.length) {
      <div id="description-box" class="full-width">
        <div class="bold-18 margin-bottom-12">{{ t('description') }}</div>
        @for (par of questDescription; track par) {
          <div class="regular-14 secondary-text-color">{{ par }}</div>
        }
      </div>
    }

    @if (quest.organization) {
      <div id="organization" class="full-width">
        <span class="by-organization-container semibold-14">
          <span class="regular-14 secondary-text-color margin-right-4">{{ t('questBy') }}</span>
          @if (quest.organization.secondaryLogo.startsWith('http')) {
            <img class="org-logo" [src]="orgLogo" alt="L">
          } @else {
            <div class="org-logo" [innerHTML]="orgLogo"></div>
          }
          {{ quest.organization.name }}
        </span>
      </div>
    } @else {
      <div id="creator" class="full-width">
        <span class="regular-14 secondary-text-color margin-right-4">{{ t('questBy') }}</span>
        <span class="semibold-14">{{ getUserName() }}</span>
      </div>
    }

    <div class="horizontal-divider"></div>

    <div id="steps" class="full-width">
      @for (step of quest['steps']; track step; let i = $index) {
        <div class="step-info-outer-container" *ngIf="doesStepHaveStartZone(step)">
          <div class="step-info-container">
            <div class="step-title semibold-16">
              <div style="display: flex; flex: 1 1 0">
                <q-svg-wrapper iconPath="project-icons/sz-marker" class="margin-right-8"></q-svg-wrapper>
                {{ t('startArea') }}
              </div>
            </div>
            <div class="step-secondary-info">
            </div>
          </div>
        </div>
        <div class="step-info-outer-container" [ngClass]="{'hidden': quest['config']?.stepsHidden && i > 0}">
          <div class="step-info-container">
            <div class="step-title semibold-16">
              <div style="display: flex;"
                   [ngStyle]="{width: hasStepTimer(step) ? 'calc(100% - 54px)' : 'calc(100% - 24px)'}">
                <div class="step-sign numbered">{{ i + 1 }}</div>
                <div>{{ step.name }}</div>
                @if (hasStepTimer(step)) {
                  <span
                    style="width: 30px; display: flex; justify-content: center; padding-top: 4px;"
                    class="secondary-text-color">
                      <q-svg-wrapper iconPath="project-icons/clock" width="20" height="20" viewBox="0 0 24 24">
                      </q-svg-wrapper>
                  </span>
                }
              </div>
            </div>
            <div class="step-secondary-info secondary-text-color regular-14">
              <div *ngFor="let sd of stepsDescriptions[i]">
                {{ sd }}
              </div>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="regular-14 secondary-text-color">{{'forMoreInfoDownloadTheApp' | transloco}}:</div>
    <div class="full-width flex gap-8">
      @if (!hideDownloadIOS()) {
        <a href="https://apps.apple.com/ua/app/questatlas/id6461825089" target="_blank"><img style="width: 150px; height: 50px" src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Download on the App Store"/></a>
      }
      @if (!hideDownloadAndroid()) {
        <a href="https://play.google.com/store/apps/details?id=world.app.questatlas" target="_blank"><img style="width: 170px; height: 50px" src="assets/images/google-play-badge.svg" alt="Get it on Google Play"/></a>
      }
    </div>
  </ng-container>
</div>
